import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ToastProvider } from "@/lib/toast";
import { AppShell } from "@/components/layout/AppShell";
import { LoadingState } from "@/components/common/States";
import LoginPage from "@/pages/Login";
import AcessoNegadoPage from "@/pages/AcessoNegado";
// Fila de hoje e a rota padrao (home) — carregada de imediato para o primeiro
// paint. As demais telas sao code-split: Kanban em particular carrega
// @dnd-kit, que nao vale pagar no bundle inicial de quem so abre a fila.
import FilaHojePage from "@/pages/FilaHoje";
const KanbanPage = lazy(() => import("@/pages/Kanban"));
const LeadsPage = lazy(() => import("@/pages/Leads"));
const DashboardPage = lazy(() => import("@/pages/Dashboard"));
const ScriptsPage = lazy(() => import("@/pages/Scripts"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
            <AuthGate />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}

function AuthGate() {
  const { status } = useAuth();

  if (status === "loading" || status === "checking_allowlist") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <LoadingState label="Verificando sessão…" />
      </div>
    );
  }

  if (status === "signed_out") {
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  if (status === "not_allowed") {
    return (
      <Routes>
        <Route path="*" element={<AcessoNegadoPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<FilaHojePage />} />
        <Route
          path="/kanban"
          element={
            <Suspense fallback={<LoadingState label="Carregando kanban…" />}>
              <KanbanPage />
            </Suspense>
          }
        />
        <Route
          path="/leads"
          element={
            <Suspense fallback={<LoadingState label="Carregando leads…" />}>
              <LeadsPage />
            </Suspense>
          }
        />
        <Route
          path="/dashboard"
          element={
            <Suspense fallback={<LoadingState label="Carregando dashboard…" />}>
              <DashboardPage />
            </Suspense>
          }
        />
        <Route
          path="/scripts"
          element={
            <Suspense fallback={<LoadingState label="Carregando scripts…" />}>
              <ScriptsPage />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
